export default Object.assign(
  JSON.parse(
    JSON.stringify(
      require("models/block/blocks/command/blueprints/change-by.json"),
    ),
  ), //make sure all the values are deeply cloned
  {
    groups: [],
    category: "animation",
    args: {
      arguments: [
        {
          code: {
            type: "string",
            value: "frame",
            title: "property",
            "hard-lock": true,
            editable: false,
          },
        },
        {
          name: "frame",
        },
      ],
    },
  },
);
